
<div class="img_wrap" (click)="addCalculator()">
    <i class="fa fa-calculator" style="color: white; font-size: 20px; cursor: pointer;"></i>
</div>
<!-- Calculator Modal -->
<div>
  <div class="calculator-container" *ngIf="isVisible" (click)="$event.stopPropagation()"
    [ngStyle]="{top: position.top + 'px', left: position.left + 'px', position: 'fixed'}"
    (mousedown)="startDrag($event)"
    (document:mousemove)="onDrag($event)"
    (document:mouseup)="stopDrag()"
    >
    <div class="calculator-header">
      <ng-container *ngIf="showHistory" >
        <i class="fa fa-calculator calculator-icon"  (click)="toggleHistory()"></i>
      </ng-container>
      <ng-container *ngIf="!showHistory" >
        <i class="fas fa-history calculator-icon"  (click)="toggleHistory()"></i>
      </ng-container>
        <!-- <button class="stay-button" (click)="toggleStayMode()" [class.active]="stayMode" >Stay</button> -->
        <i class="fas fa-thumbtack  stay-icon"  (click)="toggleStayMode()" [class.active]="stayMode" ></i>
        <i class="fas fa-times calculator-icon close-icon"  (click)="removeCalculator()"></i>
    </div>

    <div class="calculator-display" (contextmenu)="onResultContextMenu($event)">
        <div class="display-expression">{{ expression ? expression : '0' }}</div>
        <div class="display-value-row" *ngIf="showResult">
            <span class="display-value">{{ showResult ? display : '' }}</span>
          <button class="clipboard-btn" title="Copy to clipboard" (click)="copyResultToClipboard()">
            <i class="fa fa-clipboard"></i>
          </button>
        </div>
        <!-- Context menu for copy/paste -->
        <ul class="calculator-context-menu" *ngIf="contextMenuVisible" [ngStyle]="{'top.px': contextMenuPosition.y, 'left.px': contextMenuPosition.x}">
          <li (click)="copyResultToClipboard(); closeContextMenu()">Copy</li>
          <li (click)="pasteFromClipboard()">Paste</li>
        </ul>
      </div>

    <!-- Calculator Buttons -->
    <div class="calculator-buttons"  *ngIf="!showHistory" >
      <!-- Row 1 -->
      <div class="button-row">
        <button class="btn btn-function" (click)="clearAll()">AC</button>
        <button class="btn btn-function" (click)="toggleSign()">±</button>
        <button class="btn btn-function" (click)="percentage()">%</button>
        <button class="btn btn-operator" (click)="performOperation('÷')">÷</button>
      </div>

      <!-- Row 2 -->
      <div class="button-row">
        <button class="btn btn-number" (click)="inputNumber('7')">7</button>
        <button class="btn btn-number" (click)="inputNumber('8')">8</button>
        <button class="btn btn-number" (click)="inputNumber('9')">9</button>
        <button class="btn btn-operator" (click)="performOperation('×')">×</button>
      </div>

      <!-- Row 3 -->
      <div class="button-row">
        <button class="btn btn-number" (click)="inputNumber('4')">4</button>
        <button class="btn btn-number" (click)="inputNumber('5')">5</button>
        <button class="btn btn-number" (click)="inputNumber('6')">6</button>
        <button class="btn btn-operator" (click)="performOperation('-')">−</button>
      </div>

      <!-- Row 4 -->
      <div class="button-row">
        <button class="btn btn-number" (click)="inputNumber('1')">1</button>
        <button class="btn btn-number" (click)="inputNumber('2')">2</button>
        <button class="btn btn-number" (click)="inputNumber('3')">3</button>
        <button class="btn btn-operator" (click)="performOperation('+')">+</button>
      </div>

      <!-- Row 5 -->
      <div class="button-row">
        <button class="btn btn-number btn-zero" (click)="inputNumber('0')">0</button>
        <button class="btn btn-number" (click)="inputDecimal()">.</button>
        <button class="btn btn-operator" (click)="equals()">=</button>
      </div>
    </div>

<div class="history-container" *ngIf="showHistory">
  <div class="d-flex justify-content-between">
  <div class="history-header">History</div>
  <div class="history-delete-icon cursor-pointer">
    <img src="../../../../assets/img/general_icons/delete_icon.png" (click)="clearHistory()" alt="icon">
  </div>

</div>
  <div class="history-items">
    <div class="history-item" (click)="loadHistoryItem(item)" *ngFor="let item of history">{{ item }}</div>
  </div>
</div>